import Qs from 'qs'

const handledEntries = new Set()

export function entryKey (query) {
  return JSON.stringify([query.userId || '', query.envKey || '', query.ticket || '', query.pid || '', query.time || '', query.state || ''])
}

export function wasEntryHandled (key) { return handledEntries.has(key) }
export function markEntryHandled (key) { handledEntries.add(key) }

function requireSuccess (res) {
  if (!res || res.result !== '1') throw new Error((res && res.desc) || '检测状态查询失败，请重试')
  return res.data
}

export function hasSavedSurvey (value) {
  if (!value) return false
  let records = value
  try {
    if (typeof records === 'string') records = JSON.parse(records)
  } catch (error) {
    throw new Error('问卷数据暂时无法读取，请重试或联系客服')
  }
  if (!records || typeof records !== 'object' || Array.isArray(records)) throw new Error('问卷数据格式异常，请联系客服')
  // Basic-info-only records can be written by step one in older clients.
  return Object.keys(records).some(key => {
    if (['version', 'entryBasicInfo', 'basic', 'generalInfo', 'consentAgreed'].indexOf(key) >= 0) return false
    const answer = records[key]
    return answer != null && answer !== '' && (typeof answer !== 'object' || Object.keys(answer).length > 0)
  })
}

export async function needsSurveyContinuation (http, patientId, status) {
  if (!patientId || Number(status) > 1) return false
  const patient = requireSuccess(await http.get('/h5/patient/getPatientInfoDetail', { params: { patientId }, timeout: 15000 }))
  if (!patient || String(patient.ID) !== String(patientId)) throw new Error('登记信息查询异常，请重试')
  return !hasSavedSurvey(patient.RECORDS)
}

// Resolve ownership on the server using the same BIND_USER condition as the home list.
export async function resolvePidEntry (http, value) {
  const pid = String(value || '').trim()
  if (!pid) return null
  const entry = requireSuccess(await http.get('/h5/entry/resolvePid', { params: { pid }, timeout: 15000 }))
  if (!entry || !['OWNED', 'NEW', 'UNAVAILABLE'].includes(entry.status)) throw new Error('检测入口查询异常，请重试')
  if (entry.status === 'NEW') return { path: '/intake', query: { pid, mode: 'create' } }
  if (entry.status === 'UNAVAILABLE') throw new Error('当前无法访问此检测，请核对入口编号或联系客服')
  const product = entry.product
  if (!product || !product.id || String(product.serialNum || '') !== pid) throw new Error('检测入口信息不匹配，请重试')
  const detail = requireSuccess(await http.post('/eps/snDetail', Qs.stringify({ snId: product.id }), { timeout: 15000 }))
  if (!detail || String(detail.id) !== String(product.id) || String(detail.serialNum) !== pid) throw new Error('检测详情不匹配，请重试')
  const query = { patientId: product.patientId || '', serialNum: pid }
  if (detail.reportPdfUrl) return { path: '/report', query: Object.assign({ pid, projectId: product.id, personName: detail.userName || '' }, query) }
  if (await needsSurveyContinuation(http, product.patientId, detail.status)) {
    return { path: '/intake', query: { pid, patientId: product.patientId, section: 'health' } }
  }
  // Registration is determined by the saved record, not today's required form fields.
  if (product.patientId || Number(detail.status) > 1) return { path: '/projects/' + encodeURIComponent(product.id), query }
  return { path: '/intake', query: { pid, mode: 'create' } }
}



// WEBPACK FOOTER //
// ./src/utils/entryRouting.js